import { cva } from '../tokens/variants';

export const badgeVariants = cva(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-tk-sm border font-medium',
  {
    variants: {
      tone: {
        neutral:
          'bg-[var(--tk-surface-bg)] text-[var(--tk-surface-fg-muted)] border-[var(--tk-surface-border)]',
        brand:
          'bg-[var(--tk-brand-bg-subtle)] text-[var(--tk-brand-fg-on-subtle)] border-transparent',
        success:
          'bg-[var(--tk-success-bg-subtle)] text-[var(--tk-success-fg-on-subtle)] border-transparent',
        warning:
          'bg-[var(--tk-warning-bg-subtle)] text-[var(--tk-warning-fg-on-subtle)] border-transparent',
        danger:
          'bg-[var(--tk-danger-bg-subtle)] text-[var(--tk-danger-fg-on-subtle)] border-transparent',
        info: 'bg-[var(--tk-info-bg-subtle)] text-[var(--tk-info-fg-on-subtle)] border-transparent',
        outline:
          'bg-transparent text-[var(--tk-surface-fg-muted)] border-[var(--tk-surface-border)]',
      },
      size: {
        sm: 'h-5 px-1.5 text-[10px]',
        md: 'h-6 px-2 text-xs',
      },
    },
    defaultVariants: { tone: 'neutral', size: 'md' },
  },
);
